import { getTimeSuggestionsStore } from '../selectors/getTimeSuggestionsStore';
import { mutator } from 'satcheljs';
import { setTimeSuggestionsRequestState } from '../actions/internalActions';
import { TimeSuggestionsRequestState } from '../store/schema/TimeSuggestionsRequestState';
import {
    timeSuggestionsAvailableAriaLabel,
    timeSuggestionNotFound,
} from '../components/TimeSuggestions.locstring.json';

mutator(setTimeSuggestionsRequestState, actionMessage => {
    const store = getTimeSuggestionsStore(actionMessage.viewStateId);
    store.timeSuggestionsRequestState = actionMessage.timeSuggestionsRequestState;

    let ariaRequestCompletionResourceId;

    switch (actionMessage.timeSuggestionsRequestState) {
        case TimeSuggestionsRequestState.ShowSuggestions:
            ariaRequestCompletionResourceId = timeSuggestionsAvailableAriaLabel;
            break;

        case TimeSuggestionsRequestState.NoSuggestionsFound:
            ariaRequestCompletionResourceId = timeSuggestionNotFound;
            break;

        default:
            ariaRequestCompletionResourceId = '';
    }

    store.ariaRequestCompletionResourceId = ariaRequestCompletionResourceId;
});
